import * as React from 'react';
import { Alert, Input, SubmitButton } from '@ixicare/ui';
import { t } from '~/i18n';
import { State } from '~/store/types';
import connect from '~/store/connect';
import { humaniseErrorToMessage } from '~utils/error';

interface LoginContainerProps {
  onLogin: State['auth']['login'];
  loading: boolean;
  error: State['auth']['error'];
}

const LoginContainer: React.FC<LoginContainerProps> = ({ onLogin, error, loading }) => {
  const [userName, setUserName] = React.useState('');
  const [password, setPassword] = React.useState('');
  const handleSubmit = React.useCallback(
    (e: React.SyntheticEvent<HTMLFormElement>) => {
      e.preventDefault();
      onLogin(userName, password);
    },
    [userName, password]
  );
  const errMsg = React.useMemo(() => {
    if (!error) return;
    return humaniseErrorToMessage(error);
  }, [error]);
  return (
    <form onSubmit={handleSubmit}>
      {errMsg && <Alert type="error">{errMsg}</Alert>}
      <Input label={t('login.form.username')} value={userName} className="mb-20" onValueChange={setUserName} />
      <Input
        label={t('login.form.password')}
        value={password}
        type="password"
        className="mb-20"
        onValueChange={setPassword}
      />
      <SubmitButton disabled={!userName.length || !password.length} loading={loading}>
        {t('login.form.submit')}
      </SubmitButton>
    </form>
  );
};
export default connect((state: State) => ({
  onLogin: state.auth.login,
  error: state.auth.error,
  loading: state.auth.loading,
}))(LoginContainer);
